import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import index from '@/views/index'
import Knowledge from '@/views/Knowledge'
import Knowledge_view from '@/views/Knowledge/view'
import LiveList from '@/views/Livelist/Livelist'
import Live from '@/views/Live/Live'
import Lookback from '@/views/Lookback/Lookback'
import Think from '@/views/Think'
import Notice from '@/views/home/Notice'
import HelpCenter from '@/views/home/HelpCenter'
import Course from '@/views/home/Course'
import home from '@/views/home'
import play from '@/views/home/Course/play'
import Task from '@/views/Task'
import task_detail from '@/views/Task/Detail'
import Exam from '@/views/Exam'
import Exam_result from '@/views/Exam/result'
import Test from '@/views/Test'
import test_employee from '@/views/Test/employee'
import test_individual from '@/views/Test/individual'
Vue.use(Router)

export default new Router({
  //mode: 'history', 
  linkActiveClass: 'is-actived', 
  routes: [
    // {
    //   path: '/redirect',
    //   name: 'redirect',
     
    //   children: [
    //     {
    //       path: '/redirect/:path(.*)',
    //       component: (resolve) => require(['@/views/redirect'], resolve)
    //     }
    //   ]
    // },
    {
      path: '/',
      name: 'index',
      component: index
      
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      redirect: '/index',
      children:[
        {
          path: 'helpcenter',
          name: 'HelpCenter',
          component: HelpCenter
        },
        {
          path: 'notice',
          name: 'Notice',
          component: Notice
        },
        {
          path: 'course',
          name: 'Course',
          component: Course
        },
        {
          path: 'play',
          name: 'Play',
          component: play
        }
      ]
    },
    {
      path: '/Knowledge',
      name: 'Knowledge',
      component: Knowledge
    },
    {
      path: '/Knowledge/view',
      name: 'Knowledge_view',
      component: Knowledge_view
    },
    {
      path: '/Exam',
      name: 'Exam',
      component: Exam
    },
    {
      path: '/Test',
      name: 'Test',
      component: Test
    },
    {
      path: '/Test/employee',
      name: 'test_employee',
      component: test_employee
    },
    {
      path: '/Test/individual',
      name: 'test_individual',
      component: test_individual 
    },
    {
      path: '/Exam/Result',
      name: 'Exam_result',
      component: Exam_result
    },
    {
      path: '/Livelist',
      name: 'Livelist',
      component: LiveList
    },
    {
      path: '/Live',
      name: 'Live',
      component: Live
    },
    {
      path: '/Lookback',
      name: 'Lookback',
      component: Lookback
    },   
    {
      path: '/Think',
      name: 'Think',
      component: Think
    },
    {
      path: '/Task',
      name: 'Task',
      component: Task
    },
    {
      path: '/Task/Detail',
      name: 'task_detail',
      component: task_detail
    },
    {
      path: '/*',
      redirect: '/index'
    }
  ]
})
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js